import { observer } from 'mobx-react';
import moment from 'moment';
import _ from 'lodash';

import { ApiMixin } from "../ApiMixin";
import { StudentSubmitTimesheetApi } from "../../../util/api/ServiceObjects/StudentSubmitTimesheetApi";

import { Alert } from "../../Alert";


//Returns the student object, plus some helper functions
class StudentSubmitTimesheet {


    constructor(sumbission = {}) {
        this.accountId = sumbission.accountId;
        this.endDay = sumbission.endDay;
        this.timestamps = sumbission.timestamps;

        _.defaults(this, sumbission);

    }

    mutate(submission = {}) {

        //This takes all matching keys from the submission and assigns them to this object

        _.assign(this, _.pick(submission, _.keys(this)));
    }

    static generateTimestamps(timesheet, payPeriod, appStore) {
        const timestamps = []

        //If this is a new timesheet, set the timesheet to sensible default values 
        if (!timesheet) {

            const friday = moment(payPeriod).startOf('day');
            for (let i = 6; i >= 0; i--) {
                let date = friday.clone().subtract(i, "days");
                timestamps.push({
                    date: date,
                    dayName: date.format('dddd'),
                    in: null,
                    out: null,
                    lunchIn: null,
                    lunchOut: null
                });
            }
        }
        else {
            const lastSaturday = moment(payPeriod).startOf('day').subtract(6, "days");

            for (let i = 0; i < 7; i++) {
                let timestampId = timesheet.timestampIds[i];
                let timestamp = appStore.timestamps.getById(timestampId) || {};
                console.log(timestamp)

                //Submissions could be null, but we need the respective date, anyway. 
                let date = lastSaturday.clone().add(i, "days");
                if (!timesheet.date) {
                    timestamp.date = date;
                    timestamp.dayName = date.format('dddd');
                }

                timestamps.push(timestamp);
            }
        }

        return timestamps;
    }

    //Sends the object to api, and if successfull, updates the store.
    async save(appStore, timesheetId = false) {

        const fields = {
            accountId: this.accountId,
            endDay: this.endDay,
            timestamps: this.timestamps
        }


        try {

            let response = {};
            if (timesheetId) {
                response = await StudentSubmitTimesheetApi.update({ id: timesheetId });
                await appStore.getFromApi(["timestamps", "timesheets"]);
            }
            else {
                response = await StudentSubmitTimesheetApi.add(fields);
                await appStore.getFromApi(["timestamps", "timesheets"]);
            }
            
            console.log(response)
            let alert = new Alert("Success", "Save timesheet successfully.");
            appStore.addAlert(alert);


            return response;

        }
        catch (error) {
            console.log(error);
            if (error.response && error.response.data) {

                if (error.response.data.errors) {
                    //Loop through and add alerts to retval
                    _.forEach(error.response.data.errors, (errorText) => {

                        let alert = new Alert("Timesheet Error", errorText, "error", error.response.data.title);

                        appStore.addAlert(alert);
                    });
                }

                //Some other error response. 
                else {
                    let alert = new Alert("Network Error", error.response.statusText);

                    appStore.addAlert(alert);

                }
            }
            return {errors: error};
        }

    }

}

//observer(Timestamp);

export { StudentSubmitTimesheet };
